import { render, staticRenderFns } from "./DBuilderReviewerPopup.vue?vue&type=template&id=394eed5b&scoped=true&"
import script from "./DBuilderReviewerPopup.vue?vue&type=script&lang=js&"
export * from "./DBuilderReviewerPopup.vue?vue&type=script&lang=js&"
import style0 from "./DBuilderReviewerPopup.vue?vue&type=style&index=0&id=394eed5b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394eed5b",
  null
  
)

export default component.exports